import axios from "axios"
import {Message,Loading} from "element-ui"
import router from "../router/index"
// let loading ;

let instance = axios.create({
    timeout: 10*60000,
    headers: {'content-type': 'application/json'}
});

// // 添加请求拦截器
instance.interceptors.request.use(function (config) {
    config.headers['token'] = localStorage.getItem('token')
    return config;
}, function (error) {
    return Promise.reject(error);
});


// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    if (response.data.code===10086){

        localStorage.removeItem('token')
        router.push({name:'login'})
        return
    }

    if (response.data.code===200){
        return response
    }else if(response.data.code===414){
        return response
    } else {
        Message.error(response.data.msg)
        return response
    }

    // return response
}, function (error) {

    if (error.search('Timeout') === -1) {
        Message.error('系统错误')
    } else {
        Message.error('请求连接超时')
    }
    // return Promise.reject(error);
    return error
});

export default instance
